<template>
  <el-dialog
      class="dialog-com"
      v-model="internalVisible"
      destroy-on-close
      align-center
      :custom-class="dialogClass"
      :width="width"
      :draggable="true"
      @close="dialogClose"
      append-to-body
  >
    <template #header>
      <div v-html="title"></div>
    </template>

    <template #default>
      <slot/>
    </template>

    <template #footer>
      <slot name="footer"/>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import {ref} from 'vue';

// 定义组件的Props
const props = defineProps({
  width: {
    type: String || Number,
    default: '50%',
  },
  title: {
    type: String,
    default: '',
  },
  dialogClass: {
    type: String,
    default: '',
  },
});
const internalVisible = ref(false)
const updateShow = (flag: boolean) => {
  internalVisible.value = flag
}

const emit = defineEmits(['onClose']);
const dialogClose=()=>{
  emit('onClose')
}

defineExpose({
  updateShow
})

</script>

<style scoped lang="scss">

</style>
